import { render, staticRenderFns } from "./prizeShowTpyeBtn.vue?vue&type=template&id=320a14a6&scoped=true"
import script from "./prizeShowTpyeBtn.vue?vue&type=script&lang=js"
export * from "./prizeShowTpyeBtn.vue?vue&type=script&lang=js"
import style0 from "./prizeShowTpyeBtn.vue?vue&type=style&index=0&id=320a14a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a14a6",
  null
  
)

export default component.exports